import React, {useEffect, useState} from 'react';
import OnboardInput from "../../component/base/onboard-input/OnboardInput";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import OnboardDialog from "../../component/base/onboard-dialog-component/OnboardDialog";
import {paymentCreditCard, validation} from "../../model/PaymentCreditCardModel";
import OnboardPrice from "../../component/base/onboard-price-component/OnboardPrice";
import CompletedComponent from "../../component/base/completed-component/CompletedComponent";
import {changePrice, getMilesOrMil} from "../../util/Currency";
import OnboardCheckboxAgreement
    from "../../component/base/onboard-checkbox-agreement-component/OnboardCheckboxAgreement";
import {encryptDataWithPublicKey} from "../../util/Crypto";
import parse from 'html-react-parser';
import OnboardCreditCardName from "../../component/base/onboard-credit-card-component/OnboardCreditCardName";
import OnboardCreditCardDate from "../../component/base/onboard-credit-card-component/OnboardCreditCardDate";
import OnboardCreditCardNo from "../../component/base/onboard-credit-card-component/OnboardCreditCardNo";
import OnboardCreditCardCVC from "../../component/base/onboard-credit-card-component/OnboardCreditCardCVC";
import {getDistanceSalesDescriptionDomesticORInternational} from "../../util/LanguageContentManager";

const PaymentWithCreditCard = (props) => {
    const {t, i18n, navigate, setLoading, flight, user} = props.props;
    const [creditCard, setCreditCard] = useState(paymentCreditCard);
    const {payment} = props;

    const [error, setError] = useState(null);
    const [dialog, setDialog] = useState({error: false, title: "", content: ""});
    const [completed, setCompleted] = useState({
        visible: false,
        error: false,
        title: "",
        description: "",
        confirmText: ""
    });

    const buy = () => {
        if (!control().error) {
            setDialog({
                visible: true,
                title: t("payment.alert.title_credit_card").replace('{price}', changePrice(payment?.price) + " " + (flight.domestic ? 'TL' : "USD")),
                content: t("payment.alert.content")
            })
        }
    }

    const control = () => {
        const valid = validation(creditCard, t);
        setError(valid);
        return valid;
    }

    useEffect(() => {
        if (error !== null) {
            control();
        }
    }, [i18n.language])

    const handleCompleted = () => {
        setDialog({...dialog, visible: false});
        setLoading(true);
        encrypt();
    }

    const encrypt = () => {
        handlePaymentWithCreditCard({
            nameSurname: encryptDataWithPublicKey(creditCard.nameSurname),
            creditCardNumber: encryptDataWithPublicKey(creditCard.creditCardNumber),
            expiryDate: encryptDataWithPublicKey(creditCard.expiryDate),
            cvv: encryptDataWithPublicKey(creditCard.cvv),
            mail: encryptDataWithPublicKey(creditCard.mail),
            distanceSalesContract: creditCard.distanceSalesContract
        });
    }

    const handlePaymentWithCreditCard = (creditCardEncode) => {
        if (creditCardEncode.nameSurname === "Deneme Test" &&
            creditCardEncode.creditCardNumber === "1234 1234 1234 1234" &&
            creditCardEncode.expiryDate === "09/36" &&
            creditCardEncode.cvv === "123" &&
            creditCardEncode.mail === "deneme@test.com") {
            handleSuccess(true);
        } else {
            handleError(null);
        }
    }

    const handleSuccess = (data) => {
        setLoading(false);
        setCompleted({
            visible: true,
            error: false,
            title: t("payment.success.title"),
            description: t("payment.success.content"),
            confirmText: t("payment.success.confirm")
        });
        // if (data != null) {
        //     setUser({
        //         ...user,
        //         internetAccessRequest: getInternetAccessResponse(data.internetAccessResponse?.respCode),
        //         quotas: {
        //             nonPurchase: data?.userQuotaInfo?.nonPurchaseSum,
        //             purchase: data?.userQuotaInfo?.purchaseSum,
        //             favor: data?.userQuotaInfo?.favorSum
        //         }
        //     })
        // }
    }

    const handleError = (result) => {
        let content = t("payment.error.content");
        if (result !== null && result !== undefined)
            content = result;
        setLoading(false);
        setCompleted({
            visible: true,
            error: true,
            title: t("payment.error.title"),
            description: content,
            confirmText: t("payment.error.confirm")
        });
    }

    const getDistanceSalesDescription = () => {
        let isTrLang = /tr/.test(i18n.language.toLowerCase());
        return parse(t('contracts.payment_credit_card_distance_sales_pia').toString()
            .replace("{passport}", user.passportNumber ? user.passportNumber : '')
            .replace("{tckn}", user.tcIdentity ? user.tcIdentity : '')
            .replace("{date}", new Date().toLocaleDateString())
            .replace("{email}", creditCard.mail ? creditCard.mail : (user.email ? user.email : ''))
            .replace("{packagePrice}", payment?.price + (flight.domestic ? ' TL' : " USD") + " / " + payment.payMIL + getMilesOrMil(i18n, payment.payMIL))
            .replace("{packageName}", payment.title)
            .replace("{packageDesc}", payment.title)
            .replace("{packageType}", getDistanceSalesDescriptionDomesticORInternational(flight.domestic, i18n))
        )
    }

    const distanceSalesContractCheckbox = {
        label: t('payment.distance_sales_contract'),
        link: [{
            text: t('payment.distance_sales_contract_link'),
            agreement: {
                confirm: true,
                title: t('payment.distance_sales_contract_header'),
                description: getDistanceSalesDescription()
            },
        }]
    }

    return (
        <div>

            <OnboardPrice price={payment?.price} currency={flight.domestic ? 'TL' : "USD"}/>

            <div className="grid-components-mini">

                <OnboardCreditCardName value={creditCard.nameSurname}
                                       onChange={(e) => setCreditCard({...creditCard, nameSurname: e})}
                                       error={error?.nameSurname}/>

                <OnboardCreditCardNo value={creditCard.creditCardNumber}
                                     onChange={(e) => setCreditCard({...creditCard, creditCardNumber: e})}
                                     error={error?.creditCardNumber}/>

                <div className="flx">

                    <OnboardCreditCardDate value={creditCard.expiryDate}
                                           onChange={(e) => setCreditCard({...creditCard, expiryDate: e})}
                                           error={error?.expiryDate}/>

                    <OnboardCreditCardCVC value={creditCard.cvv}
                                          onChange={(e) => setCreditCard({...creditCard, cvv: e})}
                                          error={error?.cvv}/>

                </div>

                <OnboardInput placeholder={t('payment.credit_card.mail')} value={creditCard.mail}
                              length={50}
                              onChange={(e) => setCreditCard({...creditCard, mail: e})} type="email"
                              error={error?.mail}/>

            </div>

            <OnboardCheckboxAgreement
                value={creditCard.distanceSalesContract}
                error={error?.distanceSalesContract}
                onChange={(e) => setCreditCard({...creditCard, distanceSalesContract: e})}
                label={distanceSalesContractCheckbox}/>

            <div className="h-20"/>

            <OnboardButton label={t('buy')} onClick={() => buy()}/>

            <OnboardDialog moneyIcon
                           visible={dialog.visible}
                           title={dialog.title}
                           content={dialog.content}
                           confirmText={t('payment.alert.confirm')} confirmShow
                           onClickConfirm={() => handleCompleted()}
                           cancelShow cancelText={t('cancel')}
                           onClickCancel={() => setDialog({...dialog, visible: false})}/>

            <CompletedComponent
                visible={completed.visible}
                error={completed.error}
                title={completed.title}
                description={completed.description}
                confirmText={completed.confirmText} hiddenCopy
                confirm={() => {
                    if (completed.error) setCompleted({...completed, visible: false});
                    else navigate("/remaining-usage")
                }}/>

        </div>
    );
};

export default PaymentWithCreditCard;

